import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import AITrialSignupModal from 'llm/chat-library/auth/AITrialSignupModal';
import EntityStore from 'stores/EntityStore';
import {ButtonLink, ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Modal from 'ui-library/modals/Modal';

export interface Props {
  onRequestClose: () => void;
}

export default function LoggedOutModal(props: Props): JSX.Element {
  const isSessionExpired = EntityStore.currentUser() != null;
  const description = isSessionExpired
    ? 'Your session has expired. To continue, please sign in again.'
    : 'Please create an account or sign in to continue.';

  if (BenchlingConfig.LLM_ENABLE_PUBLIC_AI_TRIAL_TENANT && !isSessionExpired) {
    return <AITrialSignupModal onRequestClose={props.onRequestClose} trigger="401_error" />;
  }

  return (
    <Modal onRequestClose={props.onRequestClose} suppressHeader={true} wrapInForm={false}>
      <div className="u-lr-split">
        <div className="legacy-font-proxima-13">{description}</div>
        <div className="u-vertical-center-items">
          <ButtonLink
            className="u-spacing-right"
            buttonStyle={ButtonStyle.SECONDARY}
            href={isSessionExpired ? '/signin' : '/signup'}
            size={ButtonSize.MEDIUM}
            text={isSessionExpired ? 'Sign In' : 'Sign Up'}
          />
          <BenchlingIcon className="pull-right close" icon="close" data-dismiss="modal" />
        </div>
      </div>
    </Modal>
  );
}

export const LOGGED_OUT_MODAL_KEY = 'logged-out';
